import { jsxs as g, jsx as a, Fragment as A } from "react/jsx-runtime";
import * as y from "react";
import { u as N } from "./index-6a632112.mjs";
import { S } from "./cancelClose-87fdf326.mjs";
import { S as E } from "./checkmark-84b5274e.mjs";
import { Q as t, s as o, r as T, a as c, d as p, e as m } from "./themes-5f0b3c3d.mjs";
import { l as d } from "./lineHeights-72d3110c.mjs";
import { z as w } from "./zIndices-d07533f3.mjs";
import "./types-b577bf77.mjs";
const z = ({
  children: e,
  _stepIndex: $,
  completed: i = !1,
  error: h = !1,
  className: u = "",
  activeIndex: C,
  markerText: b = "",
  label: f
}) => /* @__PURE__ */ g(
  "li",
  {
    className: `progress-step ${h ? i ? "is-error completed" : "is-error" : i ? "is-complete" : ""}
      ${$ === C ? "is-active" : ""}
      
        ${u}`,
    children: [
      /* @__PURE__ */ g("div", { className: "progress-marker", children: [
        /* @__PURE__ */ a("span", { className: `indicator ${i ? "" : "text"}`, children: i ? h ? /* @__PURE__ */ a(S, { size: "xs" }) : /* @__PURE__ */ a(E, { size: "xs" }) : b.substring(0, 2) }),
        /* @__PURE__ */ a("span", { className: "connector" })
      ] }),
      /* @__PURE__ */ a("div", { className: "progress-text", children: /* @__PURE__ */ a("h4", { className: "progress-title", children: f }) })
    ]
  }
), l = ["10px", "50px", "18px", "8px"], r = (e) => e === "large" ? o["8x"] : e === "small" ? o["6x"] : o["7x"], P = N.div`
  display: flex;
  flex-direction: ${(e) => e.$orientation === "horizontal" ? "column" : "column-reverse"};
  @media ${t.laptopAndUp} {
    flex-direction: column;
  }

  .progress-tracker {
    display: flex;
    margin: ${o["1x"]} auto;
    padding: 0;
    list-style: none;
    width: 100%;

    @media ${t.laptopAndUp} {
      margin: ${l[0]} auto;
    }

    &.vertical {
      width: max-content;
      margin: ${o["1x"]} auto ${o["1x"]} 0;
      height: 100%;
      flex-direction: column;

      @media ${t.laptopAndUp} {
        margin: ${l[0]} auto ${o["15x"]} 0;
      }
      .progress-step {
        display: flex;
        flex: 1 1 auto;
        min-height: ${l[1]};
      }
      .progress-marker .connector {
        right: auto;
        top: calc(${r("small")} + ${o["1x"]});
        left: calc(${r("small")} / 2);
        width: 2px;
        margin: ${o["1x"]} 0;
        height: calc(100% - ${r("small")} - ${l[0]});
        border-radius: ${T["4x"]};
        @media ${t.laptopAndUp} {
          top: calc(${r("large")} + ${o["1x"]});
          left: calc(${r("large")} / 2);
          height: calc(100% - ${r("large")} - ${l[0]});
        }
      }
      .progress-text {
        padding: 0 ${r("small")} calc(${r("small")} / 2)
          ${r("small")};
        @media ${t.laptopAndUp} {
          padding: 0 ${r("large")} calc(${r("large")} / 2)
            ${r("large")};
        }
      }
    }

    &.text-top {
      .progress-text {
        height: 100%;
      }
      .progress-marker {
        top: -${r("small")};
        @media ${t.laptopAndUp} {
          top: -${r("large")};
        }
      }
    }

    &.disabled {
      cursor: not-allowed;
      filter: grayscale(1);
      opacity: 0.7;
    }

    .progress-text {
      display: none;
      padding: ${o["2x"]} ${o["2x"]};
      overflow: hidden;
      text-overflow: ellipsis;

      .tracker-text {
        font-size: ${c.xsmall};
        font-family: ${p.body};
        font-style: normal;
        font-weight: ${m.medium.S.fontWeight};
        line-height: ${d.small};
        color: ${(e) => e.theme.components.progressTracker.defaultLabelColor};
      }
      @media ${t.laptopAndUp} {
        display: block;
      }
    }

    .progress-title {
      margin-top: 0;
      margin-bottom: 0;
      font-size: ${c.small};
      font-family: ${p.body};
      font-style: normal;
      font-weight: ${m.medium.M.fontWeight};
      line-height: ${d.medium};
      color: ${(e) => e.theme.components.progressTracker.defaultLabelColor};
    }

    .progress-link {
      display: block;
      position: relative;
    }

    .progress-step {
      flex: 1 1 0%;
      margin: 0;
      padding: 0;
      min-width: ${r("small")};
      @media ${t.laptopAndUp} {
        min-width: ${r("large")};
      }

      &.pointer {
        cursor: pointer;
      }

      &.disabled {
        cursor: not-allowed;
        filter: grayscale(1);
        opacity: 0.7;
      }

      &:last-child {
        /* flex-grow: 0; */
        .progress-marker {
          .connector {
            display: none;
          }
        }
      }

      .progress-marker {
        .indicator {
          border: 2px solid
            ${(e) => e.theme.components.progressTracker.defaultColor};
          color: ${(e) => e.theme.components.progressTracker.defaultColor};
          background-color: transparent;
        }
        .connector {
          background-color: ${(e) => e.theme.components.progressTracker.defaultColor};
        }
      }

      .progress-text {
        text-align: center;
      }

      &.is-active {
        .progress-marker {
          .indicator {
            border: none;
            color: ${(e) => e.theme.components.progressTracker.activeBgColor};
            background-color: ${(e) => e.theme.components.progressTracker.activeColor};
          }
          .connector {
            background-color: ${(e) => e.theme.components.progressTracker.defaultColor};
          }
        }
        .progress-text {
          .progress-title {
            color: ${(e) => e.theme.components.progressTracker.labelColor};
          }
        }
      }

      &.is-error {
        .progress-marker {
          .indicator {
            border: 2px solid
              ${(e) => e.theme.components.progressTracker.errorColor};
            color: ${(e) => e.theme.components.progressTracker.errorColor};
            background-color: transparent;
          }
          .connector {
            background-color: ${(e) => e.theme.components.progressTracker.defaultColor};
          }
        }

        &.completed {
          .progress-marker .connector {
            background-color: ${(e) => e.theme.components.progressTracker.activeColor};
          }
        }

        .progress-text {
          .progress-title {
            color: ${(e) => e.theme.components.progressTracker.errorColor};
          }
        }

        &.is-active {
          .progress-marker {
            .indicator {
              border: none;
              color: ${(e) => e.theme.components.progressTracker.activeBgColor};
              background-color: ${(e) => e.theme.components.progressTracker.errorColor};
            }
          }
        }
      }

      &.is-complete {
        .progress-marker {
          .indicator {
            border: 2px solid
              ${(e) => e.theme.components.progressTracker.activeColor};
            color: ${(e) => e.theme.components.progressTracker.activeColor};
            background-color: transparent;
          }
          .connector {
            background-color: ${(e) => e.theme.components.progressTracker.activeColor};
          }
        }
        .progress-text {
          .progress-title {
            color: ${(e) => e.theme.components.progressTracker.labelColor};
          }
        }
        &.is-active {
          .progress-marker {
            .indicator {
              border: none;
              color: ${(e) => e.theme.components.progressTracker.activeBgColor};
              background-color: transparent;
            }
          }
        }
      }
    }

    .progress-marker {
      display: block;
      position: relative;

      .indicator {
        font-size: ${c.xxsmall};
        font-weight: ${m.medium.M.fontWeight};
        font-family: ${p.body};
        line-height: 16px;
        @media ${t.laptopAndUp} {
          font-size: ${c.small};
          line-height: ${d.medium};
        }
        font-style: normal;
        &.text {
          padding: ${l[3]};
        }
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: ${w.contentOverVideo};
        width: ${r("small")};
        height: ${r("small")};
        margin-left: none;
        margin-right: auto;
        border-radius: 50%;
        transition: background-color, border-color;
        transition-duration: 0.3s;
        @media ${t.laptopAndUp} {
          margin-left: auto;
          width: ${r("large")};
          height: ${r("large")};
        }

        svg {
          margin: auto;
          padding: 2px;
          width: ${o["4x"]};
          height: ${o["4x"]};
          @media ${t.tabletAndUp} {
            width: ${o["5x"]};
            height: ${o["5x"]};
          }
        }
      }
      .connector {
        content: '';
        display: block;
        position: absolute;
        border-radius: ${T["1x"]};
        z-index: ${w.docked};
        top: calc(${r("small")} / 2);
        right: ${o["1x"]};
        width: calc(100% - ${r("small")} - ${l[0]});
        height: 2px;
        transition: background-color 0.3s, background-position 0.3s;
        @media ${t.laptopAndUp} {
          right: calc(-50% + (${r("large")} + ${l[0]}) / 2);
          top: calc(${r("large")} / 2);
          width: calc(100% - ${r("large")} - ${l[0]});
        }
      }
    }
  }

  .stepContent {
    display: block;
    .progress-text {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      .tracker-text {
        font-size: ${c.xsmall};
        font-family: ${p.body};
        font-style: normal;
        font-weight: ${m.medium.S.fontWeight};
        line-height: ${d.small};
        color: ${(e) => e.theme.components.progressTracker.defaultLabelColor};
      }
      .progress-title {
        margin-top: 0;
        margin-bottom: 0;
        font-size: ${c.small};
        font-family: ${p.body};
        font-style: normal;
        font-weight: ${m.medium.M.fontWeight};
        line-height: ${d.medium};
        color: ${(e) => e.theme.components.progressTracker.labelColor};
      }
    }
    &.is-error {
      .progress-title {
        color: ${(e) => e.theme.components.progressTracker.errorColor};
      }
    }
    &.is-disable {
      cursor: not-allowed;
      filter: grayscale(1);
      opacity: 0.7;
    }
    &.pointer {
      cursor: pointer;
    }
    @media ${t.laptopAndUp} {
      display: none;
    }
  }
`, W = ({
  activeStep: e = 1,
  type: $ = "simple",
  className: i = "",
  children: h,
  trackerVisible: u = !0
}) => {
  const b = "horizontal";
  let f = null, v = 0, s = null;
  const U = y.Children.map(h, (n, x) => {
    if (n && y.isValidElement(n) && n.type === z) {
      const k = n.props;
      return v++, e === x + 1 && (s = k), y.cloneElement(n, {
        _stepIndex: x + 1,
        activeIndex: e,
        completed: k.completed ? k.completed : x + 1 < e,
        // disabled: disabled || childEle.disabled,
        markerText: $ === "progress" ? `${x + 1}` : k.markerText
      });
    }
    return null;
  });
  return s && (f = /* @__PURE__ */ a(
    "div",
    {
      className: `stepContent
              ${s.error ? "is-error" : ""} 
              ${s.disabled ? "is-disable" : s.onClick ? "pointer" : ""}
              ${s.className ? s.className : ""}
            `,
      onClick: (n) => s.onClick && !0 && !s.disabled && s.onClick(n),
      children: /* @__PURE__ */ g("div", { className: "progress-text", children: [
        /* @__PURE__ */ a("h4", { className: "progress-title", children: s.label }),
        u && /* @__PURE__ */ g(A, { children: [
          /* @__PURE__ */ a("span", { className: "tracker-text", children: `Step ${e} of ${v}` }),
          /* @__PURE__ */ a("br", {})
        ] }),
        s.children
      ] })
    }
  )), /* @__PURE__ */ g(P, { type: $, $orientation: b, children: [
    /* @__PURE__ */ a("ul", { className: `progress-tracker ${i}`, children: U }),
    f
  ] });
};
W.ProgressStep = z;
export {
  W as ProgressTracker
};
